import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESocketActionTypes {
  Pending = 'socket/pending',
  Succeed = 'socket/succeed',
  Failed = 'socket/failed',
}

type TSocketPending = ITypedReduxAction<ESocketActionTypes.Pending>;
type TSocketSucceed = ITypedReduxAction<ESocketActionTypes.Succeed>;
type TSocketFailed = ITypedReduxAction<ESocketActionTypes.Failed>;

export type TSocketActions = TSocketPending | TSocketSucceed | TSocketFailed;
